import { Response } from '@marketplace-web/core-api/api-client-util'

import { GetParcelDetailsResp, ParcelDto, ParcelModel } from '../types/parcel'
import { transformPackageSizeDto } from './package-size'

export const transformParcelDtoToModel = ({ dimensions, weight }: ParcelDto): ParcelModel => ({
  height: dimensions.height?.toString() || null,
  length: dimensions.length?.toString() || null,
  width: dimensions.width?.toString() || null,
  weight: weight?.toString() || null,
})

export const transformParcelModelToDto = ({
  height,
  length,
  width,
  weight,
}: ParcelModel): ParcelDto => ({
  dimensions: {
    height: height ? Number(height) : null,
    length: length ? Number(length) : null,
    width: width ? Number(width) : null,
  },
  weight: weight ? Number(weight) : null,
})

export const transformGetParcelDetailsResponse = (response: Response<GetParcelDetailsResp>) => ({
  packageSize: response.package_size ? transformPackageSizeDto(response.package_size) : null,
  maxMeasurementsExceeded: response.max_measurements_exceeded,
})
